import React from 'react';
import SectionGroup from 'app/components/general/SectionGroup';
import Loader from 'app/components/general/Loader';

export default class PaymentProcessingLoader extends React.Component<{}, {}> {
  render(): React.ReactNode {
    return (
      <div className="with-margin-top">
        <SectionGroup>
          <div className="row">
            <div className="col ">
              <div className="d-flex flex-column align-items-center text-center justify-content-center border border-round with-padding w-100 h-100">
                <Loader color="primary" className="large relative" isActive />
                <h3 className="with-margin-top w-100">
                  Payment is processing. Please wait, this may take up to 10
                  seconds.
                </h3>
              </div>
            </div>
          </div>
        </SectionGroup>
      </div>
    );
  }
}
